module.exports = __webpack_public_path__ + "static/media/2.89c5c901.jpg";